import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { BotIcon, MessageCircleIcon } from 'lucide-react';
import { useAIAssistantChat } from '../contexts/AIAssistantChatContext';
export function AIAssistant() {
  const {
    openChat
  } = useAIAssistantChat();
  return null; // Component not currently in use, return null to prevent errors
}